import useKeyboardShortcuts from "utils/hooks/useKeyboardShortcuts";

const KeyboardShortcuts = () => {
  useKeyboardShortcuts();

  return null;
};

export default KeyboardShortcuts;
